<div class="white-background">
    <div class="d-flex flex-column flex-md-row justify-content-between align-items-center text-center text-md-start">
        <div class="p-4">
            <img class="" ngSrc="/assets/img/logo.png" alt="LOGO" width="340" height="68" />
        </div>

        <div class="tagline">
            <h5 class="text-weight-bold" style="color: #3BA378">
                World’s Most Reliable Certification Manager for
                <i>Competitive</i> Professionals
            </h5>
        </div>
    </div>
    <div class="text-center">
        <img class="mt-2 mb-5" ngSrc="/assets/img/Welcome-to-Your-New-Wallet!.png" alt="" width="374" height="89" />
    </div>
    <div class="container white-background">
        <mat-card class="shadow-lg card-form">
            <mat-card-content class="rounded-lg text-center">
                <h3 class="my-4" style="font-weight: bold">Reset Password Request</h3>
                <form [formGroup]="form">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Email Address</mat-label>
                        <input type="text" matInput formControlName="email" >
                        <mat-icon matPrefix>mail</mat-icon>
                        <mat-error *ngIf="submitted && f['email'].invalid && f['email'].errors['required']">Email is required</mat-error>
                        <mat-error *ngIf="submitted && f['email'].invalid && f['email'].errors?.['email']">Email must be a valid email address</mat-error>

                    </mat-form-field>
                    <div class="form-group">
                        <div class="d-flex justify-content-center mt-2">
                            <button style="margin-right: 10px;"
                                    (click)="onSubmit()"
                                    mat-raised-button
                                    class="mt-2 form-button">
                                <mat-icon>shield</mat-icon>Reset Password
                            </button>
                            <button
                                    mat-raised-button
                                    class="mt-2 form-button"
                                    type="button"
                                    [routerLink]="'/login'">
                                <mat-icon>chevron_right</mat-icon>Cancel
                            </button>
                        </div>

                    </div>
                </form>
            </mat-card-content>
        </mat-card>
    </div>
</div>